import { useCallback } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

export const useRecaptcha = action => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const verifyRecaptcha = useCallback(async () => {
    if (!executeRecaptcha) {
      console.log('Execute recaptcha not yet available');
      return null;
    }

    try {
      const token = await executeRecaptcha(action);
      return token; // Return the token to the caller
    } catch (error) {
      console.error('Error during reCAPTCHA execution', error);
      return null;
    }
  }, [executeRecaptcha, action]);

  return verifyRecaptcha;
};
export default useRecaptcha;
